import React from 'react';
import PropTypes from 'prop-types';
import { EmptyTile } from './EmptyTile.jsx';
import { TilesWrapper } from '../StyledComponents';

export const TabTilePlaceholder = ({ showStats }) => (
  <TilesWrapper>
    <div className="row">
      <div className="large-12">
        <EmptyTile showStats={showStats} />
        <EmptyTile showStats={showStats} />
        <EmptyTile showStats={showStats} />
        <EmptyTile showStats={showStats} />
      </div>
    </div>
  </TilesWrapper>
);

TabTilePlaceholder.propTypes = {
  showStats: PropTypes.bool,
};
